import ConfigDetails from '@/views/config/details.vue';
import ConfigTeams from '@/views/config/teams.vue';
import ConfigIndicators from '@/views/config/indicators.vue';
import ConfigActions from '@/views/config/actions.vue';
import ConfigCfgPages from '@/views/config/configurable-pages.vue';
import ConfigMeetings from '@/views/config/meetings.vue';
import ConfigProblems from '@/views/config/problems.vue';
import ConfigLocations from '@/views/config/locations.vue';


export default [
  {
    path: 'details',
    component: ConfigDetails,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'teams',
    component: ConfigTeams,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'indicators',
    component: ConfigIndicators,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'actions',
    component: ConfigActions,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'configurable-pages',
    component: ConfigCfgPages,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'meetings',
    component: ConfigMeetings,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'problems',
    component: ConfigProblems,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
  {
    path: 'locations',
    component: ConfigLocations,
    meta: {
      requireConfig: true,
      noCheckLogin: true,
    },
  },
];
